import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import { EventCard } from "../components/EventCard";
import Grid from "@mui/material/Grid";
import SocialMetaTags from "../components/header/SocialMetaTags";
import { Typography } from "@mui/material";
import { getEvents } from "../services/firebase";

export const EventsList = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setIsError(false);
    getEvents().then((events) => {
      if (events && !events.error) {
        setEvents(events);
      } else {
        setIsError(true);
      }
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return <p>Loading...</p>;
  }
  if (isError) {
    return <p>Sorry, we couldn't find any events.</p>;
  }

  return (
    <>
      <SocialMetaTags
        title="Upcoming Events at The Cola St. Louis"
        description="Check out the upcoming events at The Cola St. Louis. From live music to comedy shows, we have something for everyone!"
        image="/cola-stl.svg"
        page="events"
        siteName="The Cola St. Louis"
      />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="h3" component="h1" sx={{ mt: 2, mb: 2 }}>
          Upcoming Events
        </Typography>
        <Typography variant="subtitle1" sx={{ px: 2, mb: 2, mt: 3 }}>
          @ The Cola St. Louis
        </Typography>
      </Box>

      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "stretch",
          mt: 2,
          p: 2,
        }}
      >
        {events.map((event) => (
          <Grid key={event.id} item xs={12} sm={6}>
            <EventCard event={event} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
